import { Backdrop, Box, Button, DialogActions } from "@mui/material";
import React from "react";

interface IBackDrop {
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
}

const CustomBackDrop: React.FC<IBackDrop> = ({ open, onClose, children }) => {
    const childrenWithProps = React.cloneElement(children as React.ReactElement, { onClose });

    return (
        <Backdrop open={open} sx={{ backgroundColor: "rgba(255, 255, 255, 0.5)", zIndex: 1300 }}>
          <Box
            sx={{
              width: "60vw", // 70% da largura da viewport
              height: "60vh", // 70% da altura da viewport
              backgroundColor: "white", // Cor de fundo para visibilidade
              borderRadius: 2, // Cantos arredondados
              boxShadow: 3, // Sombra para destaque
              padding: 2, // Espaçamento interno
              display: "flex",
              flexDirection: "column",
              justifyContent: "center", // Centralizar o conteúdo verticalmente
              alignItems: "center", // Centralizar o conteúdo horizontalmente
            }}
          >
            {childrenWithProps}
            <DialogActions>
              <Button onClick={onClose} color="primary">
                Cancelar
              </Button>
            </DialogActions>
          </Box>
        </Backdrop>
      );
};
export default CustomBackDrop;